import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';
import type { CSSProperties } from '@resi-media/resi-ui';

export const S = {
  backButton: (theme: Theme) =>
    css({
      color: theme.palette.common.white,
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      borderRadius: theme.shape.borderRadius.circle,
      width: `calc(${theme.spacing.l} + 4.4rem)`,
      height: `calc(${theme.spacing.l} + 4.4rem)`,
      fontSize: '4.4rem',
      cursor: 'pointer',
      border: 0,
      transition: 'transform 150ms ease',
      willChange: 'width, height',
      svg: {
        filter: 'drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4))',
      },
      '&:hover': {
        transform: 'scale(1.2)',
      },
    }),
  backButtonContainer: (controlsVisible?: boolean) =>
    css({
      position: 'absolute',
      top: 0,
      left: 0,
      paddingLeft: '3rem',
      paddingRight: '3rem',
      paddingTop: '3rem',
      paddingBottom: '3rem',
      alignItems: 'normal',
      flexGrow: '1',
      justifyContent: 'flex-start',
      transition: 'opacity 300ms',
      opacity: 0,
      visibility: 'hidden',
      ...(controlsVisible && {
        opacity: 1,
        visibility: 'visible',
      }),
    }),
  duration: () =>
    css({
      fontSize: '2.4em',
      margin: '0.6em 0px 1.2em',
    }),
  global: (_theme: Theme) =>
    css({
      '.resi-player': {},
    }),
  globalFullScreen: (theme: Theme) =>
    css({
      'html, body': {
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        position: 'relative',
        fontSize: '10px',
        background: 'black',
        '@media only screen and (max-height: 720px)': {
          fontSize: '9px',
        },
        '@media only screen and (max-height: 648px)': {
          fontSize: '8px',
        },
        '@media only screen and (max-height: 576px)': {
          fontSize: '7.2px',
        },
        '@media only screen and (max-height: 540px)': {
          fontSize: '6.6px',
        },
        '@media only screen and (max-height: 480px)': {
          fontSize: '6px',
        },
        '@media only screen and (max-height: 360px)': {
          fontSize: '5.3px',
        },
        '@media only screen and (max-height: 240px)': {
          fontSize: '4.8px',
        },
      },
      '.resi-player': {
        '& #aspect-ratio': {
          position: 'static !important' as CSSProperties['position'],
        },
        '& .body4': {
          fontSize: '1.6rem !important',
          fontFamily: `${theme.typography.fontFamilyBody} !important`,
        },
        '& .icon-button': {
          transition: 'transform 150ms ease',
          willChange: 'width, height',
          '&:hover': {
            transform: 'scale(1.3)',
          },
        },
      },
    }),
  loadingSpinner: () =>
    css({
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate3d(-50%, -50%, 0)',
      fontSize: '10vh',
    }),
  overlay: (theme: Theme) =>
    css({
      height: '100%',
      left: '0',
      margin: '0',
      overflow: 'hidden',
      padding: '0',
      position: 'absolute',
      top: '0',
      width: '100%',
      backgroundColor: `${theme.palette.surface.default}50`,
    }),
  overlayTextContainer: (theme: Theme) =>
    css({
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: theme.palette.common.white,
      height: '100%',
      width: '100%',
      padding: '12%',
      position: 'relative',
      userSelect: 'none',
      fontSize: '10px',

      '@media only screen and (max-height: 720px)': {
        fontSize: '9px',
      },

      '@media only screen and (max-height: 648px)': {
        fontSize: '8px',
      },

      '@media only screen and (max-height: 576px)': {
        fontSize: '7.2px',
      },

      '@media only screen and (max-height: 540px)': {
        fontSize: '6.6px',
      },

      '@media only screen and (max-height: 480px)': {
        fontSize: '6px',
      },

      '@media only screen and (max-height: 360px)': {
        fontSize: '5.3px',
      },

      '@media only screen and (max-height: 240px)': {
        fontSize: '4.8px',
      },
    }),
  pauseOverlay: (theme: Theme) =>
    css({
      fontSize: '1.8em',
      margin: '0px 0px 0px 0.4em',
      color: theme.palette.text.secondary,
    }),
  synopsis: (theme: Theme) =>
    css({
      fontSize: '1.8em',
      color: theme.palette.text.secondary,
      width: '60%',
      margin: '0px',
    }),
  title: (theme: Theme) =>
    css({
      fontSize: '5.4em',
      color: theme.palette.common.white,
      fontWeight: 'bold',
      marginBottom: '0px',
      marginTop: '0px',
    }),
  videoContainer: () =>
    css({
      position: 'absolute',
      width: '100%',
      height: '100%',
    }),
  videoContainerLoading: () =>
    css({
      visibility: 'hidden',
    }),
};
